import { useState, useRef, useEffect, forwardRef } from 'react';
import {
    Avatar,
    Box,
    Chip,
    ClickAwayListener,
    Divider,
    Fade,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Paper,
    Popper,
} from '@mui/material';
import MainCard from '../ui-component/MainCard';
import { Link, useNavigate } from 'react-router-dom';
import UserProfile from '../../../assets/images/users/user-profile.svg';
import theme from '../theme/Theme';
import SettingsIcon from '@mui/icons-material/Settings';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import Color from '../color/Color';

// ==============================|| PROFILE MENU ||============================== //


const ChangePassword = forwardRef((props, ref) => {
    return (
        <MenuItem component={Link} ref={ref} {...props} to="/change-password">
            <ListItemIcon>
                <LockResetOutlinedIcon />
            </ListItemIcon>
            <ListItemText>{'Change password'}</ListItemText>
        </MenuItem>
    );
});

const UpdateProfile = forwardRef((props, ref) => {
    return (
        <MenuItem component={Link} ref={ref} {...props} to="/edit-profile">
            <ListItemIcon>
                <ManageAccountsOutlinedIcon />
            </ListItemIcon>
            <ListItemText>{'Edit Profile'}</ListItemText>
        </MenuItem>
    )
})

const ProfileSection = () => {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const navigate = useNavigate();

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }

        prevOpen.current = open;
    }, [open]);

    return (
        <>
            <Chip
                sx={{
                    height: '48px',
                    alignItems: 'center',
                    borderRadius: '27px',
                    transition: 'all .2s ease-in-out',
                    borderColor: Color.Main,
                    backgroundColor: Color.Main,
                    '&[aria-controls="menu-list-grow"], &:hover': {
                        borderColor: Color.Main,
                        background: Color.Main,
                        color: Color.Main,
                        '& svg': {
                            stroke: Color.Normal
                        }
                    },
                    '& .MuiChip-label': {
                        lineHeight: 0
                    }
                }}
                icon={
                    <Avatar
                        src={UserProfile}
                        sx={{
                            ...theme.typography.mediumAvatar,
                            margin: '8px 0 8px 8px !important',
                            cursor: 'pointer'
                        }}
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        color="inherit"
                    />
                }
                label={<SettingsIcon color={theme.palette.primary.main} />}
                variant="outlined"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                color="primary"
            />
            <Popper
                placement="bottom-end"
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 14]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => (
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                    <Box sx={{ p: 2 }}>
                                        <UpdateProfile />
                                        <Divider sx={{p:0.4}} ></Divider>
                                        <ChangePassword />
                                        <Divider sx={{p:0.4}} ></Divider>
                                        <MenuItem onClick={() => {
                                            localStorage.clear();
                                            navigate("/login");
                                        }}>
                                            <ListItemIcon>
                                                <LogoutIcon />
                                            </ListItemIcon>
                                            <ListItemText>{'Logout'}</ListItemText>
                                        </MenuItem>
                                        </Box>
                                </MainCard>
                            </ClickAwayListener>
                        </Paper>
                    </Fade>
                )}
            </Popper>
        </>
    );
};

export default ProfileSection;
